import { render, staticRenderFns } from "./DispatchFilesToTeam.vue?vue&type=template&id=c726d884&scoped=true&"
import script from "./DispatchFilesToTeam.vue?vue&type=script&lang=js&"
export * from "./DispatchFilesToTeam.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c726d884",
  null
  
)

export default component.exports